import React from 'react';
import { useAppContext } from '../contexts/AppContext';
import { getTranslatedCategory } from '../utils/translations';

const getFodmapBadge = (level) => {
  if (level.toLowerCase() === 'low') {
    return {
      class: 'bg-success',
      icon: 'fa-check-circle',
      text: 'LOW'
    };
  }
  if (level.toLowerCase() === 'high') {
    return {
      class: 'bg-danger',
      icon: 'fa-exclamation-triangle',
      text: 'HIGH'
    };
  }
  return {
    class: 'bg-warning',
    icon: 'fa-question-circle',
    text: level.toUpperCase()
  };
};

const FoodCard = ({ food }) => {
  const { darkMode, language } = useAppContext();
  
  // Get the correct name based on language
  const displayName = language === 'sk' && food.name_sk ? food.name_sk : food.name;
  // Get the translated category
  const translatedCategory = getTranslatedCategory(food.category, language);
  // Get FODMAP badge info
  const fodmapInfo = getFodmapBadge(food.fodmap);

  return (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
      <div 
        className={`card h-100 border-0 shadow-lg ${darkMode ? 'bg-dark text-light' : 'bg-white'}`}
        style={{ 
          borderRadius: '15px',
          transition: 'all 0.3s ease',
          transform: 'translateY(0)',
          overflow: 'hidden'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-5px)';
          e.currentTarget.style.boxShadow = darkMode 
            ? '0 15px 35px rgba(255,255,255,0.1)' 
            : '0 15px 35px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = darkMode 
            ? '0 10px 25px rgba(255,255,255,0.05)' 
            : '0 10px 25px rgba(0,0,0,0.1)';
        }}
      >
        {/* FODMAP Badge */}
        <div className="position-relative">
          <div 
            className={`position-absolute top-0 end-0 ${fodmapInfo.class} text-white px-3 py-2 d-flex align-items-center`}
            style={{ 
              borderBottomLeftRadius: '15px',
              fontSize: '0.85rem',
              fontWeight: '600',
              zIndex: 10
            }}
          >
            <i className={`fas ${fodmapInfo.icon} me-2`}></i>
            {fodmapInfo.text}
          </div>
        </div>

        <div className="card-body p-4 pb-0 d-flex flex-column">
          {/* Food Name */}
          <div className="mb-3">
            <h5 
              className="card-title mb-2" 
              style={{ 
                fontSize: '1.25rem',
                fontWeight: '600',
                lineHeight: '1.3',
                color: darkMode ? '#ffffff' : '#2c3e50'
              }}
            >
              {displayName}
            </h5>
          </div>

          {/* Category */}
          <div className="mb-3 flex-grow-1">
            <div className="d-flex align-items-center">
              <div 
                className={`rounded-pill px-3 py-2 d-inline-flex align-items-center ${
                  darkMode 
                    ? 'bg-secondary bg-opacity-50 text-light' 
                    : 'bg-light text-dark'
                }`}
                style={{ fontSize: '0.9rem' }}
              >
                <i className="fas fa-tag me-2 text-primary" style={{ fontSize: '0.8rem' }}></i>
                <span className="fw-medium">{translatedCategory}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodCard;
